import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.applyFilter('');
  }

  filter(event) {
    const value = (event && event.target && event.target.value) || (this.hasInputTarget ? this.inputTarget.value : '');
    this.applyFilter(value);
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  applyFilter(term) {
    const normalized = this.normalize(term);
    const items = this.element.querySelectorAll('.dropdown-item[data-value]');
    items.forEach((item) => {
      const text = this.normalize(item.dataset.text || item.textContent);
      const matches = normalized.length === 0 || text.includes(normalized);
      if (matches) {
        item.classList.remove('hidden');
        item.style.display = '';
      } else {
        item.classList.add('hidden');
        item.style.display = 'none';
      }
    });
  }

  normalize(value) {
    return (value || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }
}
